import { firebaseAuth } from '@kurotetsu/share/vendors/firebase';
import {
  signInWithEmailAndPassword,
  signOut,
  type UserCredential
} from 'firebase/auth';

export type { UserCredential };

export const login = (
  email: string,
  password: string
): Promise<UserCredential> => {
  return signInWithEmailAndPassword(firebaseAuth, email, password);
};

export const logout = (): Promise<void> => {
  return signOut(firebaseAuth);
};

export { firebaseAuth };
